import { render, staticRenderFns } from "./DeleteDomain.vue?vue&type=template&id=6441846f&scoped=true&"
import script from "./DeleteDomain.vue?vue&type=script&lang=js&"
export * from "./DeleteDomain.vue?vue&type=script&lang=js&"
import style0 from "./DeleteDomain.vue?vue&type=style&index=0&id=6441846f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6441846f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
